import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CardCvvElement } from '@recurly/react-recurly';
import { useMediaQuery } from '@nebula/hooks';

import { Element, InputState } from '../constants.ts';
import useFocusHandler from '../hooks/useFocusHandler';
import useFormValidation from '../hooks/useFormValidation';
import useInputHandler from '../hooks/useInputHandler';
import { ValidationStatusIcon, Cvv } from './Icons';
import { getFieldValidationState } from '../../../helpers/getFieldValidationState';
import { SecurityCode, SecurityInput, SecurityIcon } from './index.styles';
import useFieldAnalytics from './hooks/useFieldAnalytics';

const SecurityCodeComponent = ({
  onSecurityCodeStateChange = () => {},
  onFormValidityChange,
  highlightedField,
  isBillDateChange = false,
}) => {
  const [inputStates, setInputStates] = useState({ [Element.Cvv]: InputState.Standard });

  const isSmallMobile = useMediaQuery('(min-width: 365px)');

  const { newInputStates, handleInputChange, getRecurlyInputStyle } = useInputHandler(inputStates, setInputStates);
  const { focusedElement, handleFocus, handleBlur } = useFocusHandler();

  useFormValidation([newInputStates], onFormValidityChange);

  useFieldAnalytics(newInputStates, isBillDateChange);

  const handleCvvChange = event => {
    // handleInputChange returns the computed state, which we pass synchronously
    // to the parent to ensure it has the latest CVV state before form submission
    // validation runs (fixes race condition on quick submit).
    const newState = handleInputChange('cvv', event);
    onSecurityCodeStateChange(newState);
  };

  return (
    <SecurityCode>
      <SecurityInput
        $state={getFieldValidationState(Element.Cvv, highlightedField, newInputStates, InputState)}
        $focused={focusedElement === Element.Cvv}
      >
        <CardCvvElement
          onChange={handleCvvChange}
          onFocus={handleFocus(Element.Cvv)}
          onBlur={handleBlur}
          style={getRecurlyInputStyle('CVC/CVV')}
        />
        <ValidationStatusIcon
          state={getFieldValidationState(Element.Cvv, highlightedField, newInputStates, InputState)}
        />
      </SecurityInput>
      <SecurityIcon>
        {isSmallMobile && <Cvv />}
        Last 3 digits on the back of your card
      </SecurityIcon>
    </SecurityCode>
  );
};

SecurityCodeComponent.propTypes = {
  onSecurityCodeStateChange: PropTypes.func,
  onFormValidityChange: PropTypes.func.isRequired,
  highlightedField: PropTypes.bool,
  isBillDateChange: PropTypes.bool,
};

export default SecurityCodeComponent;
